import { render } from "./MdcMenu.vue?vue&type=template&id=d04ca84e"
import script from "./MdcMenu.vue?vue&type=script&lang=js"
export * from "./MdcMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__